import { PublishersRoot, ScreenRoot } from "types";

export const PublishersRootDefinition: ScreenRoot = {
  name: PublishersRoot,
  routePath: ["/publishers/*"],
  accessPath: "publisher",
};
